module.exports = __webpack_public_path__ + "img/logo-2.afca5ad8.png";